import React, { useEffect, useState, useMemo } from 'react';
import {
  Row,
  Col
} from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import { formatDateTime } from '../../utils/format';
import MonitorCard from '../../components/MonitorCard';
import { fetchUtxoBalances, fetchTransferWalletBalances, fetchFilterOptions } from '../../services/monitorService';

const AssetBalance = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filterOptions, setFilterOptions] = useState({ chains: [], symbols: [] });

  const initialFilters = useMemo(() => {
    const f = {};
    for (const [key, value] of searchParams.entries()) {
      f[key] = value;
    }
    return f;
  }, []);

  const handleMonitorSearch = (filters) => {
    const next = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      next.set(key, value);
    }
    setSearchParams(next, { replace: true });
  };

  useEffect(() => {
    fetchFilterOptions().then((res) => {
      if (res) setFilterOptions(res);
    }).catch(() => {});
  }, []);
  const utxoBalanceColumns = [
    { title: '链名称', dataIndex: 'chain', key: 'chain' },
    {
      title: '资产',
      dataIndex: 'symbol',
      key: 'symbol',
      render: (text, record) => record.asset_id ? (
        <Link to={`/dashboard/explorer/asset/${record.asset_id}`}>{text}</Link>
      ) : text,
    },
    {
      title: '余额',
      dataIndex: 'balance',
      key: 'balance',
      align: 'right',
      render: (val) => val ? parseFloat(val).toFixed(8) : '0',
    }
  ];

  const transferWalletBalanceColumns = [
    { title: '链名称', dataIndex: 'chain', key: 'chain' },
    {
      title: '资产',
      dataIndex: 'symbol',
      key: 'symbol',
      render: (text, record) => record.asset_id ? (
        <Link to={`/dashboard/explorer/asset/${record.asset_id}`}>{text}</Link>
      ) : text,
    },
    {
      title: '地址',
      dataIndex: 'address',
      key: 'address',
      ellipsis: false,
      render: (text, record) => record.address_id ? (
        <Link to={`/dashboard/explorer/address/${record.address_id}`} style={{ fontFamily: 'monospace' }}>{text}</Link>
      ) : text,
    },
    {
      title: '余额',
      dataIndex: 'balance',
      key: 'balance',
      align: 'right',
      render: (val) => val ? parseFloat(val).toFixed(8) : '0',
    },
    { title: '余额更新时间', dataIndex: 'updated_at', key: 'updated_at', render: (d) => formatDateTime(d) }
  ];

  return (
    <div className="asset-balance-container">
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <MonitorCard
            title="UTXO 总和"
            columns={utxoBalanceColumns}
            fetchFunction={fetchUtxoBalances}
          />
        </Col>
        <Col xs={24}>
          <MonitorCard
            title="归集地址余额"
            columns={transferWalletBalanceColumns}
            fetchFunction={fetchTransferWalletBalances}
            initialFilterValues={initialFilters}
            onSearch={handleMonitorSearch}
            filters={[
              { field: 'chain', placeholder: '按链名称', suggestions: filterOptions.chains },
              { field: 'symbol', placeholder: '按资产', suggestions: filterOptions.symbols },
              { field: 'address', placeholder: '按地址' },
            ]}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AssetBalance;
